import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Breadcrumbs as SashBreadcrumbs, Container } from '@pella/sash-framework';

const Breadcrumbs = ({ data, className, ...other }) => {
	if (!data) return null;

	const updatePageLinkSchema = () => {
		if (!data?.back_pages?.[0]) return;

		const updatedBackPages = data.back_pages.map((page) => {
			return {
				title: page.cta_title,
				url: page.destination?.[0]?.destination,
			};
		});

		return updatedBackPages;
	};

	return (
		<Container className={className || ''}>
			<SashBreadcrumbs
				className={`py-4`}
				linkComponent={Link}
				pages={updatePageLinkSchema()}
				current={data.active_page}
				isGatsby
				{...other}
			/>
		</Container>
	);
};

Breadcrumbs.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default Breadcrumbs;
